import { cn } from '@bem-react/classname';

export const cnModalLayout = cn('ModalLayout');
